"use client";

import {
  getSessionErrorIds,
  initBugReporter,
  instrumentedFetch,
  reportError as reportErrorToBackend,
} from "@getyesman/bug-reporter";

// Matches App\BugReport\Enum\BugTargetRepository::fromApp() — the empreinte's `app` field.
const APP_NAME = "home";

// TODO(bug-report levier A follow-up): APP_VERSION isn't injected by gitops yet (no tenant
// overlay sets it on the pod). Hardcoded until that lands — the backend's SourcemapResolver
// and RegressionDetector already degrade gracefully on a missing/placeholder version.
const APP_VERSION = "unknown";

let apiBaseUrlPromise: Promise<string | null> | null = null;

function loadApiBaseUrl(): Promise<string | null> {
  if (typeof window === "undefined") return Promise.resolve(null);

  apiBaseUrlPromise ??= fetch("/api/config")
    .then((response) => (response.ok ? response.json() : null))
    .then((data: unknown) => {
      const apiUrl = (data as { apiUrl?: unknown } | null)?.apiUrl;
      return typeof apiUrl === "string" && apiUrl.length > 0 ? apiUrl : null;
    })
    .catch(() => null);

  return apiBaseUrlPromise;
}

/**
 * Fire-and-forget, like the package's own reportError(): the config fetch and the report
 * POST both happen asynchronously in the background — callers never await this.
 */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
  void loadApiBaseUrl().then((apiBaseUrl) => {
    if (!apiBaseUrl) return;

    initBugReporter({
      app: APP_NAME,
      version: APP_VERSION,
      endpoint: `${apiBaseUrl}/api/bug-report/report`,
    });
    reportErrorToBackend(error, context);
  });
}

export { instrumentedFetch, getSessionErrorIds };
